interface ScrollIconProps {
  className?: string
  size?: number
  colored?: boolean
}

export const ScrollIcon: React.FC<ScrollIconProps> = ({
  className,
  size = 24,
  colored = false,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill={colored ? '#EBC28E' : 'currentColor'}>
        <path d="M5.24717 9.97107C4.54902 9.31661 4.06905 8.46573 4.06905 7.46215V7.35306C4.1345 5.65131 5.5308 4.25502 7.23255 4.21138H18.1194C18.403 4.2332 18.6211 4.42955 18.6211 4.71317V13.9419C18.8611 13.9856 18.992 14.0292 19.232 14.0946C19.4284 14.16 19.6901 14.3128 19.6901 14.3128V4.71317C19.6684 3.84049 18.9702 3.14233 18.0976 3.14233H7.23255C4.87628 3.18597 3 5.10588 3 7.46215C3 8.83663 3.6327 10.0147 4.63629 10.822C4.70175 10.8875 4.76719 10.9529 4.96355 10.9529C5.29081 10.9529 5.50898 10.691 5.48716 10.4292C5.48716 10.1893 5.39989 10.102 5.24717 9.97107Z" />
        <path d="M17.8364 14.5524H9.30594C8.73869 14.5524 8.28053 15.0107 8.28053 15.5996V16.8215C8.30233 17.3887 8.78232 17.8687 9.34958 17.8687H9.98222V16.8215H9.34958V15.6215C9.34958 15.6215 9.50229 15.6215 9.69864 15.6215C10.7677 15.6215 11.575 16.6251 11.575 17.6941C11.575 18.654 10.7022 19.8541 9.26229 19.7668C7.97509 19.6795 7.27693 18.545 7.27693 17.6941V7.28734C7.27693 6.82918 6.88422 6.43646 6.42607 6.43646H5.5752V7.50551H6.20789V17.716C6.16425 19.7886 7.69145 20.8359 9.26229 20.8359L17.8583 20.8577C19.5818 20.8577 21 19.4613 21 17.716C20.9781 15.9487 19.5818 14.5524 17.8364 14.5524ZM19.9091 17.7596C19.8655 18.8723 18.9492 19.7668 17.8364 19.7668L11.8586 19.745C12.3385 19.1996 12.6222 18.4796 12.6222 17.6941C12.6222 16.4724 11.9022 15.6215 11.9022 15.6215H17.8583C18.9928 15.6215 19.9309 16.5597 19.9309 17.6941L19.9091 17.7596Z" />
        <path d="M15.5445 7.67951H9.1084V6.61047H15.5445C15.8281 6.61047 16.068 6.85045 16.068 7.13408C16.068 7.43952 15.8499 7.67951 15.5445 7.67951Z" />
        <path d="M15.5445 12.698H9.1084V11.629H15.5445C15.8281 11.629 16.068 11.869 16.068 12.1527C16.068 12.4581 15.8499 12.698 15.5445 12.698Z" />
        <path d="M16.6791 10.1888H9.1084V9.11972H16.6791C16.9626 9.11972 17.2026 9.35971 17.2026 9.64335C17.2026 9.94872 16.9626 10.1888 16.6791 10.1888Z" />
      </g>
    </svg>
  )
}
